export const SECRET_KEY = "Ktd14xmglkEZIuR3yxZNU5ELrJE3lAIEtqUWAc6F0/k=";

export const BASE_API_URL = "https://apiv2.shwenarsin.com/api/app/miniapp/";

export const BASE_API_V2_URL = "https://apiv2.shwenarsin.com/api/app/";

export const BASE_API_V3_URL = "https://apiv3.shwenarsin.com/api/app/";

export const BASE_PAYMENT_API_URL = "https://apiv2.shwenarsin.com/api/miniapp/payment"